var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHonors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E5F5F6",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2728 29.091H22.7273C27.2728 29.091 29.0909 27.2728 29.0909 22.7273V17.2728C29.0909 12.7273 27.2728 10.9091 22.7273 10.9091H17.2728C12.7273 10.9091 10.9091 12.7273 10.9091 17.2728V22.7273C10.9091 27.2728 12.7273 29.091 17.2728 29.091Z",
    stroke: "#0E7F8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5454 11.3091V20.3819C24.5454 22.1728 23.2636 22.8728 21.6909 21.9273L20.4909 21.2091C20.2182 21.0455 19.7818 21.0455 19.5091 21.2091L18.3091 21.9273C16.7363 22.8637 15.4545 22.1728 15.4545 20.3819V11.3091",
    stroke: "#0E7F8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2728 29.091H22.7273C27.2728 29.091 29.0909 27.2728 29.0909 22.7273V17.2728C29.0909 12.7273 27.2728 10.9091 22.7273 10.9091H17.2728C12.7273 10.9091 10.9091 12.7273 10.9091 17.2728V22.7273C10.9091 27.2728 12.7273 29.091 17.2728 29.091Z",
    stroke: "#0E7F8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5454 11.3091V20.3819C24.5454 22.1728 23.2636 22.8728 21.6909 21.9273L20.4909 21.2091C20.2182 21.0455 19.7818 21.0455 19.5091 21.2091L18.3091 21.9273C16.7363 22.8637 15.4545 22.1728 15.4545 20.3819V11.3091",
    stroke: "#0E7F8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonors);
export default __webpack_public_path__ + "static/media/honors.629b328431fe73f2ac7d0db6ea9da1bc.svg";
export { ForwardRef as ReactComponent };